import {Button, Image} from "antd-mobile";
import {useEffect, useState} from "react";
import {RightOutline} from 'antd-mobile-icons'
import {useNavigate} from "react-router-dom";
import {kLoginInfo} from "../../common/Utils";
import {useTranslation} from "react-i18next";


const Me = () => {
    const {t} = useTranslation();
    const navigate = useNavigate()
    const [userName, setUserName] = useState('');

    useEffect(() => {
        _getLocalData();
    }, [])
    /**
     * 退出
     */
    const _getLocalData = () => {
        const data: string | null = window.localStorage.getItem(kLoginInfo);
        if (data) {
            const curUserData: API.CurrentUser = JSON.parse(data) as API.CurrentUser;
            if (curUserData) {
                setUserName(curUserData.salesName);
            }
        }
    }
    const _logoutOnClick = () => {
        window.localStorage.removeItem(kLoginInfo);
        navigate('/login');
    }
    const _listItemOnClick = (index: number, isRight: boolean) => {
        if (isRight) {
            if (index === 1) {
                navigate('/tab/home')
            }
            else if (index === 2) {
                navigate('/me/checkUser')
            }
        }
    }

    const _renderListItem = (imgUrl: string, title: string, isLine: boolean, isRight: boolean, index: number) => {
        return <div style={{display: "flex", flexDirection: "column", paddingLeft: 10, paddingRight: 10}}
                    onClick={() => {
                        _listItemOnClick(index, isRight)
                    }}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                <div style={{
                    display: "flex",
                    flexDirection: 'row',
                    alignItems: "center",
                    padding: '18px 0'
                }}>
                    {/*{imgUrl ? <Image width={26} height={26} fit={"contain"} src={imgUrl}/> : null}*/}
                    <span style={{fontSize: 16, color: '#060606', fontWeight: '400', marginLeft: 8}}>{title}</span>
                </div>
                {isRight ? <RightOutline/> : null}
            </div>
            {isLine ? <div style={{backgroundColor: '#EFEFEF', height: 1, width: '100%'}}/> : null}
        </div>
    }

    return (
        <div style={{width: '100%'}}>
            <div className={'me-box'} style={{
                display: "flex",
                padding: '50px 0',
                marginTop: 30,
                flexDirection: "column",
                alignItems: 'center'}}>
                <Image width={62} height={62} fit='contain' src={require('../../assets/profile_pic_def.png')}/>
                <span style={{fontSize: 20, color: '#060606', fontWeight: 'bold', marginTop: 15}}>{userName}</span>
            </div>
            <div className={'me-box'}>
                {_renderListItem(require('../../assets/profile_icon_abount.png'), t('me_about'), true, false, 0)}
                {_renderListItem(require('../../assets/profile_icon_order.png'), t('me_my_orders'), false, true, 1)}
                {_renderListItem(require('../../assets/profile_icon_order.png'), t('me_my_check_user'), false, true, 2)}
            </div>
            <div style={{marginTop: 40, textAlign: "center"}}>
                <Button onClick={_logoutOnClick} shape='rounded' fill='outline' color='primary'>{t('me_logout')}</Button>
            </div>
        </div>
    );
}
export default Me
